export default __webpack_public_path__ + "static/media/SWT1650.34I-39009_-22955_0.83867b61.jpg";